import { useStore } from "@tanstack/react-form";
import { handleFormErrorMessage } from "../../shared/utils";
import { FormHelperText, FormHelperTextProps } from "@mui/material";
import { useFormContext } from "../../contexts/form-context";

export interface FormErrorTextProps extends FormHelperTextProps {
    name?: string
}

export default function FormErrorText({
    name = "",
    ...props
}: FormErrorTextProps) {
    const form = useFormContext();
    const [errorList] = useStore(form.store, (state) => [state.errors]);
    const [hasError, errors] = handleFormErrorMessage(name, errorList);

    if (!hasError || !errors) return <></>
    return <FormHelperText {...props} error>{errors}</FormHelperText>
}